import {ModelData} from "./model/modelData";

export const availableModels: {
  [modelKey: string]: { [modelYear: string]: ModelData };
} = {
  // HX 22年 HC 23年 HY 25 年
  'smart #1': {
    '2022': {
      parts: [
        'Air Bag Driver',
        'Air Bag FAR Side',
        'Air Bag Front Side Left',
        'Air Bag Front Side Right',
        'Air Bag Passenger',
        'Air Curtain Left',
        'Air Curtain Right',
        'Brake Fluid',
        'Compressor Oil',
        'Coolant',
        'Seat Belt First Row Left',
        'Seat Belt First Row Right',
        'Seat Belt Second Row Side',
        'Tire Repair Emulsion',
        'Transmission Oil1',
        'Transmission Oil2',
        'Windshield washer fluid',
      ],
      scips: [
        '245321034',
        '236503760',
        '235770784',
        '245356211',
        '245356172',
        '245321034-four-wheel',
      ],
    },
  },
  'smart #3': {
    '2023': {
      parts: [
        'Air Bag Driver',
        'Air Bag FAR Side',
        'Air Bag Front Side Left',
        'Air Bag Front Side Right',
        'Air Bag Passenger',
        'Air Curtain Left',
        'Air Curtain Right',
        'Brake Fluid',
        'Compressor Oil',
        'Coolant',
        'Seat Belt First Row Left',
        'Seat Belt First Row Right',
        'Seat Belt Second Row Side',
        'Starter Battery',
        'Tire Repair Emulsion',
        'Transmission Oil',
        'Windshield washer fluid',
      ],
      scips: [
        '245321034',
        '236503760',
        '235770784',
        '245356211',
        '245356172',
        '245321034-four-wheel',
      ],
    },
  },
  'smart #5': {
    '2025': {
      parts: [
        'Air Bag Driver',
        'Air Bag FAR Side LH',
        'Air Bag FAR Side RH',
        'Air Bag Front Side Left',
        'Air Bag Front Side Right',
        'Air Bag Passenger',
        'Air Curtain Left',
        'Air Curtain Right',
        'Brake Fluid',
        'Compressor Oil',
        'Coolant',
        'Seat Belt First Row Left',
        'Seat Belt First Row Right',
        'Seat Belt Second Row Side',
        'Tire Repair Emulsion',
        'Transmission Oil',
        'Windshield washer fluid',
      ],
      scips: [
        '245321034',
        '236503760',
        '235770784',
        '245356211',
        '245356172',
        '245321034-four-wheel',
      ],
    },
  },
};
